import { API, UpdateFieldInput } from "@thenounproject/lingo-core";
import { createAsyncAction } from "@actions/actionCreators";
import { toSnakeCase } from "@helpers/objectTransforms";

type Args = {
  spaceId: number;
  id: string;
  name?: string;
  description?: string;
  displayOrder?: number;
  fields?: UpdateFieldInput[];
};

const [useUpdateProductType, updateProductType] = createAsyncAction(
  "productType/update",
  async ({ spaceId, id, name, description, displayOrder, fields }: Args) => {
    const res = await API.call<{ productType: string }>({
      endpoint: `spaces/${spaceId}/product-types/${id}`,
      method: "PUT",
      data: {
        name,
        description,
        display_order: displayOrder,
        fields: toSnakeCase(fields),
      },
    });
    return { ...res, result: res.result.productType };
  }
);

export default useUpdateProductType;
export { updateProductType };
